import React, {Component} from 'react';
import {getProblem, getSubjects} from "../services/SubjectService";
import {ProblemView} from './ProblemView'

export class Problem extends Component {
    static displayName = Problem.name;

    constructor(props) {
        super(props);
        this.state = {
            subjectKey: this.props.subjectKey,
            themeKey: this.props.themeKey,
            templateId: this.props.templateId,
            loading: true,
            loadingFirstTime: true,
            answered: false,
            reportResult: this.props.onResult,
            onNewProblem: this.props.onNewProblem,
            mode: this.props.mode
        };
        this.handleResult = this.handleResult.bind(this);
    }

    onNewProblem() {
        if (!this.state.onNewProblem) return;
        this.state.onNewProblem({});
    }

    componentDidMount() {
        this.fetchProblem();
    }

    handleResult(event) {
        if (this.state.answered) {
            this.fetchProblem();
            return;
        }

        this.setState({answered: true, correct: event.correct}, () => {
            if (!this.state.reportResult) return;
            this.state.reportResult({correct: this.state.correct, problem: this.state.problem});
        });
    }

    renderProblem(subject, theme, problem) {
        return <ProblemView key={problem.id} subject={subject} theme={theme} problem={problem}
                            onResult={this.handleResult}/>;
    }

    render() {
        let problem = this.state.loadingFirstTime
            ? null
            : this.renderProblem(this.state.subject, this.state.theme, this.state.problem);
        let loader = this.state.loading
            ? <p><em>Indlæser opgave ...</em></p>
            : null;

        return (
            <div>
                {problem}
                {loader}
            </div>
        );
    }

    fetchProblem() {
        this.onNewProblem();
        this.setState({loading: true, answered: false, correct: false});
        getSubjects().then(subjects => {
            const subject = subjects.filter(d => d.key === this.state.subjectKey)[0];
            const theme = subject.themes.filter(t => t.key === this.state.themeKey)[0];
            const params = {
                lastProblemRating: this.state.problem ? this.state.problem.rating : 0,
                templateId: this.state.templateId
            };
            getProblem(this.state.subjectKey, this.state.themeKey, this.state.mode, params).then(problem => {
                this.setState({
                    subject: subject,
                    theme: theme,
                    problem: problem,
                    loading: false,
                    loadingFirstTime: false
                });
            });
        });
    }
}